import React, { useEffect, useState } from 'react';
import api from '../api';

// Super admin: prepojenie účtov tej istej osoby naprieč firmami.
interface Link { id: string; email: string; first_name: string; last_name: string; role: string; tenant_name: string }

export default function UserLinksEditor({ userId }: { userId: string }) {
  const [links, setLinks] = useState<Link[]>([]);
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);

  const load = () => api.get(`/users/${userId}/links`).then(r => setLinks(r.data || [])).catch(() => setLinks([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [userId]);

  const add = async () => {
    if (!email.trim()) return;
    setBusy(true); setMsg(null);
    try {
      await api.post(`/users/${userId}/links`, { email: email.trim() });
      setEmail('');
      setMsg({ ok: true, text: 'Účty sú prepojené.' });
      await load();
    } catch (e: any) {
      setMsg({ ok: false, text: e?.response?.data?.error || 'Prepojenie sa nepodarilo.' });
    } finally { setBusy(false); }
  };

  const unlink = async () => {
    setBusy(true); setMsg(null);
    try {
      await api.delete(`/users/${userId}/links`);
      setMsg({ ok: true, text: 'Účet je odpojený.' });
      await load();
    } catch (e: any) {
      setMsg({ ok: false, text: e?.response?.data?.error || 'Odpojenie sa nepodarilo.' });
    } finally { setBusy(false); }
  };

  return (
    <div style={{ gridColumn: '1 / -1', borderTop: '1px solid #e5e7eb', paddingTop: '0.75rem' }}>
      <div style={{ fontSize: '0.85rem', fontWeight: 600, color: '#374151', marginBottom: '0.25rem' }}>Prepojené účty</div>
      <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '0.5rem' }}>
        Tá istá osoba v inej firme. Medzi prepojenými účtami sa prepína bez hesla.
      </div>
      {links.length > 0 && (
        <ul style={{ margin: '0 0 0.5rem', paddingLeft: '1.1rem', fontSize: '0.85rem', color: '#374151' }}>
          {links.map(l => <li key={l.id}>{l.tenant_name} · {l.email}</li>)}
        </ul>
      )}
      <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="e-mail účtu v inej firme"
          style={{ flex: 1, minWidth: 220, padding: '0.45rem 0.6rem', border: '1px solid #d1d5db', borderRadius: 6, fontSize: '0.85rem' }} />
        <button type="button" onClick={add} disabled={busy || !email.trim()}
          style={{ padding: '0.45rem 0.9rem', background: '#2563eb', color: '#fff', border: 0, borderRadius: 6, cursor: 'pointer', fontSize: '0.85rem', opacity: busy || !email.trim() ? 0.6 : 1 }}>
          Prepojiť
        </button>
        {links.length > 0 && (
          <button type="button" onClick={unlink} disabled={busy}
            style={{ padding: '0.45rem 0.9rem', background: '#fff', color: '#b91c1c', border: '1px solid #fecaca', borderRadius: 6, cursor: 'pointer', fontSize: '0.85rem' }}>
            Odpojiť tento účet
          </button>
        )}
      </div>
      {msg && <div style={{ marginTop: '0.4rem', fontSize: '0.8rem', color: msg.ok ? '#15803d' : '#b91c1c' }}>{msg.text}</div>}
    </div>
  );
}
